import { FULL_PAGE_SEARCH_PAGE, FULL_PAGE_SEARCH_PATH } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';

export const searchRoute: GlobalHomePageRoute = createGlobalRoute({
	layout: 'home',
	nav4Layout: 'expanded',
	exact: true,
	name: FULL_PAGE_SEARCH_PAGE,
	path: FULL_PAGE_SEARCH_PATH,
	query: ['text?'],
});
